module.exports = __webpack_public_path__ + "img/img-19.dbdc5112.webp";